export default __webpack_public_path__ + "static/media/educators4.253e9d95.jpg";